import type { actions } from '@luxuryescapes/contract-svc-lab-v2'
import request from 'api/requestUtils'

type PreviewResponse = actions['getPreviewCampaign']['responses'][200]['content']['application/json']

export async function getLabCampaignPreview(id: string, signal?: AbortSignal): Promise<PreviewResponse['result']> {
  const response = await request.get<PreviewResponse>(
    `/api/lab/v2/preview/campaigns/${encodeURIComponent(id)}`,
    { signal, timeout: 5000, excludeBrand: true, credentials: 'omit' },
  )
  return response.result
}
